import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Iframe from "react-iframe";
import style from "./index.module.scss";
import { Box, Breadcrumbs, Typography } from "@mui/material";
import Links from "@mui/material/Link";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Loading from "../../components/Loading";

const ViewProcessPage = () => {
  const [loading, setLoading] = useState(true);

  
  // Get processAssociationId and source page from navigation state
  const location = useLocation();
  const processAssociationId = location.state?.id || "";
  // Get sourcePage from state, fallback to sessionStorage (original entry point), or default to 'edit'
  const sourcePage = location.state?.sourcePage;
  const xevmpdId= location.state?.xevmpdId;
  const params= location.state?.params;
  
  const { t } = useTranslation();
  const navigate = useNavigate();
  const origin = window.location.origin.replace('xevmpd.', 'PAT.');


  const IframeUrl = `${origin}/process/${processAssociationId}`;
  console.log("ViewProcess IframeUrl", IframeUrl);
  console.log("ViewProcess processAssociationId", processAssociationId);

  useEffect(() => {
    // Set loading to false after component mounts
    setLoading(false);
  }, []);

  const handleBackToProducts = () => {
    navigate("/xevmpd");
  };

  const handleBackToViewProduct = () => {
    if (sourcePage === 'edit') {
      navigate("/edit-xevmpd",{state:{params, mode:"edit"}});
    } else {
      navigate("/view-xevmpd",{state:{params, mode:"view"}});
    }
  };

  const secondBreadItemDisplayName = () => {
    
      if (sourcePage === 'edit') {
        return `${t("Edit xEVMPD")}-${xevmpdId}`;
      } else {
        return `${t("View xEVMPD")}-${xevmpdId}`;
      }
   
  };


  return (
    <Box className={style["process-container"]} sx={{ height: "100vh", width: "100%" }}>
      <Box className={style["breadcrumb-container"]} sx={{ marginLeft:"32px", marginTop:"5px"}} >
        <Breadcrumbs
          separator={<Typography component="span" sx={{ color: "#737373", fontSize: "14px" }}>/</Typography>}
          aria-label="breadcrumb"
        >
          <Links
            underline="hover"
            color="primary"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handleBackToProducts();
            }}
          >
            {t("xEVMPD")}
          </Links>
          <Links
            underline="hover"
            color="primary"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handleBackToViewProduct();
            }}
          >
            {secondBreadItemDisplayName()}
          </Links>
          <Typography color="text.primary">{t("workflow.viewProcess")}</Typography>
        </Breadcrumbs>
      </Box>
      <Box className={style["iframe-container"]} sx={{ height: "calc(100vh - 180px)", width: "100%" }}>
        {loading ? (
          <Loading open={loading} />
        ) : (
          <Iframe
            url={IframeUrl}
            width="100%"
            height="100%"
            id="process-view-iframe"
            className={style["process-iframe"]}
            display="block"
            position="relative"
            onLoad={() => setLoading(false)}
          />
        )}
      </Box>
    </Box>
  );
};

export default ViewProcessPage;
